export default __webpack_public_path__ + "static/media/thumb_large.c99edd20.jpg";